module.exports = __webpack_public_path__ + "ae804f485a4cb3374e67c25668c1f73f.png";